<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report'" [commentSlug]="'fund-treemap-actual'" [cardChartSource]="cardChartSource">
  <mat-card-header class="detail-card-header">
    <mat-card-title data-test="title">Treemap Actual - % of Total NAV</mat-card-title>
  </mat-card-header>

  @if ((treemapDataFromPartnershipInvestment$ | async); as treemapData) {
    @if (treemapData.length === 0) {
      <mat-card-content class="detail-card-content" style="color: grey">
        No data available to display the treemap.
      </mat-card-content>
    }
    <div class="chart-container">
      <canvas #fundTreemap id="fund-treemap" [class.hidden]="treemapData.length === 0 || filteredData.length === 0"></canvas>
    </div>
    @if (treemapData.length > 0 && filteredData.length === 0) {
      <mat-card-content class="detail-card-content" style="color: grey">
        Cannot display the treemap because all assets are missing the GP NAV.
      </mat-card-content>
    }
    @if (filteredData.length > 0 && missingGpNAVAssets.length > 0) {
      <valumize-info-panel
        appearance="WARNING"
        [message]="'The treemap is incomplete because the following assets are missing the GP NAV: ' + missingGpNAVAssets.join(', ')">
      </valumize-info-panel>
    }
  }

  @if (filteredData.length > 0) {
    <mat-card-actions class="detail-card-actions legend-container">
        <span class="legend-title">Color by Total TVPI:</span>
        <div class="gradient-bar">
          <span class="label start">0</span>
          <span class="label midpoint">1</span>
          <span class="label end">>3</span>
        </div>
        <valumize-card-comments-button [commentScope]="'fund-report'" [commentSlug]="'fund-treemap-actual'"></valumize-card-comments-button>
    </mat-card-actions>
  }

</mat-card>
